<template>
  <div class="eco-event-info">
    <div class="cols align-items-center">
      <div v-if="description" class="font-bold font-size-15">{{ description }}</div>
      <table class="popup-details">
        <tr>
          <th>{{ $t('reports.trips.eco-events.event-info.time') }}</th>
          <td>{{ data.time }}</td>
        </tr>
        <tr>
          <th>{{ $t('dashboard.quick-map.info-window.address') }}</th>
          <td>{{ data.address }}</td>
        </tr>
        <tr v-if="data.speed != null">
          <th>{{ $t('dashboard.quick-map.info-window.speed') }}</th>
          <td>{{ speedLabel }}</td>
        </tr>
        <tr v-if="data.refuel">
          <th>{{ $t('reports.trips.eco-events.refuel') }}</th>
          <td>{{ data.refuel }}</td>
        </tr>
        <tr v-if="data.fuel">
          <th>{{ $t('dashboard.quick-map.info-window.fuel') }}</th>
          <td>{{ fuelLabel }}</td>
        </tr>
        <tr v-if="data.driver">
          <th>{{ $t('dashboard.quick-map.info-window.driver') }}</th>
          <td>{{ driverLabel }}</td>
        </tr>
        <tr v-if="data.power != null">
          <th>{{ $t('generic.params-map.battery-current') }}</th>
          <td>{{ powerLabel }}</td>
        </tr>
        <tr v-if="data.rpm != null">
          <th>{{ $t('generic.params-map.engine-rpm') }}</th>
          <td>{{ rpmLabel }}</td>
        </tr>
        <tr v-if="data.throttle != null">
          <th>{{ $t('generic.params-map.accelerator-pedal-position') }}</th>
          <td>{{ throttleLabel }}</td>
        </tr>
        <tr v-if="data.temperature != null">
          <th>{{ $t('generic.params-map.temperature') }}</th>
          <td>{{ data.temperature }} °C</td>
        </tr>
        <tr v-if="data.humidity != null">
          <th>{{ $t('generic.params-map.humidity') }}</th>
          <td>{{ data.humidity }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EcoEventsInfo',
  props: {
    data: Object,
    description: {
      type: String,
      required: false,
    }
  },
  computed: {
    speedLabel() {
      return this.data.speed.toFixed(0) + ' ' + this.$t('generic.kmph');
    },
    fuelLabel() {
      return this.data.fuel === null ? '-' : (this.data.fuel.toFixed(0) + ' ' + this.$t('generic.litres'));
    },
    driverLabel() {
      return this.data.driver !== 'no driver' ? this.data.driver : '-'
    },
    powerLabel() {
      return this.data.power.toFixed(2) + ' V';
    },
    rpmLabel() {
      return this.data.rpm.toFixed(0);
    },
    throttleLabel() {
      return this.data.throttle + ' %';
    }
  },
};
</script>

<style scoped lang="scss">
.eco-event-info {
  background: #FFFFFF;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
}
</style>
